import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { ConfigurationService, Oauth2Service, ReferrerService, StorageService } from '@common';
import { Observable, of } from 'rxjs';

export const YAMA_STORAGE_KEY: string = 'yama_cart';
@Injectable({
    providedIn: 'root',
})
export class ReferrerResolver {
    constructor(
        private oAuth2Service: Oauth2Service,
        private configService: ConfigurationService,
        private referrerService: ReferrerService,
        private storageService: StorageService,
    ) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<any> {
        if (!this.storageService.get(YAMA_STORAGE_KEY, false)) {
            this._handleYamaReferrers();
        }

        return of(null);
    }

    private _handleYamaReferrers() {
        const yamaReferrers: string[] = this.configService.getData()?.global.yama?.referrers || [];
        if (this.referrerService.isReferrerValid(yamaReferrers)) {
            const dayMilliseconds: number = 3600 * 24 * 1000;
            const expirationDate: number = new Date().getTime() + dayMilliseconds;
            this.storageService.set(YAMA_STORAGE_KEY, true, false, expirationDate);
            if (this.oAuth2Service.loggedPicasso()) {
                this.oAuth2Service.logout();
            }
        }
    }
}
